export const sanitizeOptions: {
  ALLOWED_TAGS: string[];
  ALLOWED_ATTR: string[];
} = {
  ALLOWED_TAGS: [
    "p",
    "br",
    "strong",
    "em",
    "b",
    "i",
    "u",
    "ul",
    "li",
    "ol",
    "a",
  ],
  ALLOWED_ATTR: ["href", "target"],
};
